import satisfactionSurveyQuestionnaire from "./satisfactionSurveyQuestionnaire";
import satisfactionSurveyCourse from "./satisfactionSurveyCourse";

const satisfactionSurveyService = [
    {
        matcher: 'satisfactionSurveyQuestionnaire',
        reply: config => {
            return [200, satisfactionSurveyQuestionnaire];
        }
    },
    {
        matcher: 'satisfactionSurveyCourse',
        reply: config => {
            return [200, satisfactionSurveyCourse];
        }
    }
]

export default satisfactionSurveyService;